export default{
    info: "Información",
    informe: "Informe",
    notas: "Notas",
    presupuesto: "Presupuesto",
    rma: "RMA",
    repuestos: "Repuestos",
    adjuntos: "Adjuntos",
    firma: "Firma",
    checklist: "Checklists",
    fallas: "Fallas",
    datosCliente: "Datos del cliente",
    datosEquipo: "Datos del equipo",
    datosAdicionales: "Datos adicionales",
    asignarTecnico: "Asignar técnico",
    general: "General",
    financiero: "Financiero",
    ubicacion: "Ubicación",
    obra: "Obra",
    historial: "Historial",
    contacto: "Contacto",
    facturacion: "Facturación",
    observaciones: "Observaciones",
    equipos: "Equipos",
    sucursales: "Sucursales",
    
}